import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {NewsState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class NewsQuery extends QueryEntity<NewsState> {

  constructor(protected store: Store) {
    super(store);
  }

}
